import { render, staticRenderFns } from "./transfer-description-column.vue?vue&type=template&id=0c9f7a34&scoped=true"
import script from "./transfer-description-column.vue?vue&type=script&lang=js"
export * from "./transfer-description-column.vue?vue&type=script&lang=js"
import style0 from "./transfer-description-column.vue?vue&type=style&index=0&id=0c9f7a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f7a34",
  null
  
)

export default component.exports